'use client';
import { PropsWithChildren, ReactNode, useRef } from 'react';

type Props = {
    title: ReactNode;
    position?: 'top' | 'bottom' | 'left' | 'right';
} & PropsWithChildren;

export default function Tooltip({ title, position = 'bottom', children }: Props) {
    const ref = useRef<HTMLDivElement>(undefined);

    let positioning = '';
    switch (position) {
        case 'top':
            positioning = 'left-1/2 bottom-0 mb-6';
            break;
        case 'bottom':
            positioning = 'left-1/2 top-0 mt-6';
            break;
        case 'left':
            positioning = 'right-0 top-1/2 mr-6';
            break;
        case 'right':
            positioning = 'left-0 top-1/2 ml-6';
            break;
    }

    return (
        <div
            className="font-body group relative inline-block cursor-pointer"
            onMouseEnter={() => {
                const elem = ref.current;
                if (!elem) return;

                const parent = elem.parentElement;

                if (position === 'top' || position === 'bottom') {
                    const parentBounds = parent?.getBoundingClientRect();
                    const halfWidth = elem.clientWidth / 2;
                    if (!parentBounds) {
                        elem.style.marginLeft = `${-halfWidth}px`;
                        return;
                    }

                    const leftSpace = parentBounds.left - 4;
                    const rightSpace = window.outerWidth - parentBounds.right - 4;
                    let marginLeft = halfWidth <= leftSpace ? -halfWidth : -leftSpace;
                    marginLeft = halfWidth <= rightSpace ? marginLeft : -halfWidth - rightSpace;
                    elem.style.marginLeft = `${marginLeft}px`;
                } else {
                    elem.style.marginTop = `${-elem.clientHeight / 2}px`;
                }
            }}>
            {children}
            <div
                role="tooltip"
                ref={ref as any}
                className={`bg-dark-green pointer-events-none absolute z-10 hidden w-64 p-2 ${positioning} text-center text-sm text-white group-hover:block`}>
                {title}
            </div>
        </div>
    );
}
